/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 50161:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(8290);

/***/ }),

/***/ 50265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var RichTextPart = __webpack_require__(24677);
module.exports = {
  RichTextPart: RichTextPart
};

/***/ }),

/***/ 24677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _slicedToArray = (__webpack_require__(90353)["default"]);
__webpack_require__(3524);
__webpack_require__(92448);
__webpack_require__(63317);
__webpack_require__(59344);
__webpack_require__(4182);
var React = __webpack_require__(16689);
var Link = __webpack_require__(97589);
var _require = __webpack_require__(89816),
  decode = _require.decode;
var _require2 = __webpack_require__(137),
  linkRegex = _require2.linkRegex,
  emptyRegex = _require2.emptyRegex,
  boldRegex = _require2.boldRegex,
  cleanupRegex = _require2.cleanupRegex;
var RichTextPart = function RichTextPart(_ref) {
  var part = _ref.part,
    deeplinkData = _ref.deeplinkData,
    customClass = _ref.customClass;
  if (part.startsWith('<b><a href=') || part.startsWith('<a href=')) {
    var _deeplinkData$isCusto, _deeplinkData$customD;
    var partWithoutLineBreaks = part.replace(/(\r?\n|\r)/g, ' ');
    var matchLink = partWithoutLineBreaks.match(linkRegex);
    // Extract link and text from the anchor tag
    var _matchLink = _slicedToArray(matchLink, 3),
      link = _matchLink[1],
      text = _matchLink[2];
    var validatedLink = cleanupRegex.test(link) ? link.replace(cleanupRegex, '') : link;
    return /*#__PURE__*/_jsx(Link, {
      link: {
        url: validatedLink,
        onlyLink: true,
        isCustomDeeplink: (_deeplinkData$isCusto = deeplinkData.isCustomDeeplink) !== null && _deeplinkData$isCusto !== void 0 ? _deeplinkData$isCusto : false,
        customDeeplink: (_deeplinkData$customD = deeplinkData.customDeeplink) !== null && _deeplinkData$customD !== void 0 ? _deeplinkData$customD : ''
      },
      label: text,
      text: part.startsWith('<b><a href=') || boldRegex.test(text) ? /*#__PURE__*/_jsx("b", {}, void 0, decode(text.replace(/<\/?b>/g, ''))) : decode(text),
      customClass: customClass,
      element_order: text
    });
  }
  if (emptyRegex.test(part)) return null; // Return null if part is empty or contains only '&nbsp;'

  // eslint-disable-next-line react/no-danger
  return /*#__PURE__*/_jsx("p", {
    dangerouslySetInnerHTML: {
      __html: part
    }
  });
};
RichTextPart.defaultProps = {
  customClass: null
};
module.exports = RichTextPart;

/***/ }),

/***/ 8290:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
__webpack_require__(43133);
__webpack_require__(83790);
__webpack_require__(72341);
__webpack_require__(61000);
__webpack_require__(3524);
__webpack_require__(92448);
var React = __webpack_require__(16689);
var _require = __webpack_require__(137),
  emptyRegex = _require.emptyRegex,
  getSplitedContent = _require.getSplitedContent;
var _require2 = __webpack_require__(50265),
  RichTextPart = _require2.RichTextPart;
var RichTextHandler = function RichTextHandler(_ref) {
  var content = _ref.content,
    deeplinkData = _ref.deeplinkData,
    customClass = _ref.customClass;
  var splitedContent = getSplitedContent(content);
  if (emptyRegex.test(content)) return null;
  return splitedContent.map(function (part, index) {
    return /*#__PURE__*/_jsx(RichTextPart, {
      part: part,
      deeplinkData: deeplinkData,
      customClass: customClass
    }, index);
  });
};
RichTextHandler.defaultProps = {
  content: '',
  deeplinkData: {},
  customClass: null
};
module.exports = RichTextHandler;

/***/ }),

/***/ 137:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(3524);
__webpack_require__(80685);
var regexContent = /(<b><a\b[^>]*>.*?<\/a>|<a\b[^>]*>.*?<\/a>)/;
var linkRegex = /href="(.*?)">(.*)<\/a>/;
var emptyRegex = /^(&nbsp;|\s)*$/;
var boldRegex = /<b>(.*)<\/b>/;
var cleanupRegex = /(%|\?|target=|""|<|>| ).*/g;
var getSplitedContent = function getSplitedContent(content) {
  return content.split(regexContent);
};
module.exports = {
  linkRegex: linkRegex,
  emptyRegex: emptyRegex,
  boldRegex: boldRegex,
  cleanupRegex: cleanupRegex,
  getSplitedContent: getSplitedContent
};

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 90353:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ 97589:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/link");

/***/ }),

/***/ 43133:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.map.js");

/***/ }),

/***/ 83790:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.constructor.js");

/***/ }),

/***/ 72341:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.map.js");

/***/ }),

/***/ 61000:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ 3524:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.exec.js");

/***/ }),

/***/ 92448:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.test.js");

/***/ }),

/***/ 63317:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.match.js");

/***/ }),

/***/ 59344:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.replace.js");

/***/ }),

/***/ 80685:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.split.js");

/***/ }),

/***/ 4182:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.starts-with.js");

/***/ }),

/***/ 89816:
/***/ ((module) => {

"use strict";
module.exports = require("html-entities");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(50161);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map